function replaceTaxText() {
  const taxSpans = document.querySelectorAll('.b2b-nt-cart-tax-price span:last-child');

  taxSpans.forEach((element) => {
    if (element.textContent.includes('Included') || element.textContent.includes('included')) {
      element.innerHTML = element.innerHTML.replace(/Included|included/g, 'inkl.');
    }
  });
}

const BSS_LOCK_MARKER = '.bss-lock-element';
const BSS_PURCHASE_CONTEXT = '.product-card, .product-card--overlay, .product__info-wrapper';
const BSS_PURCHASE_CONTROL =
  '.product-form__submit, button[name="add"], input[name="add"], .shopify-payment-button';
const BSS_DISABLED_ATTRIBUTE = 'data-bss-lock-atc-disabled';

function disableBssPurchaseContext(context) {
  if (!context.hasAttribute(BSS_DISABLED_ATTRIBUTE)) {
    context.setAttribute(BSS_DISABLED_ATTRIBUTE, 'true');
  }

  context.querySelectorAll(BSS_PURCHASE_CONTROL).forEach((control) => {
    if (control.getAttribute('aria-disabled') !== 'true') {
      control.setAttribute('aria-disabled', 'true');
    }

    if ('disabled' in control && !control.disabled) {
      control.disabled = true;
    }
  });
}

function applyBssAddToCartLocks() {
  document.querySelectorAll(BSS_PURCHASE_CONTEXT).forEach((context) => {
    if (context.querySelector(BSS_LOCK_MARKER)) {
      disableBssPurchaseContext(context);
    }
  });

  const mainProductIsLocked = Boolean(
    document.querySelector('[id*="MainProduct"] .product__info-wrapper .bss-lock-element')
  );

  if (mainProductIsLocked) {
    document.querySelectorAll('.sticky-atc-bar, sticky-atc-bar').forEach(disableBssPurchaseContext);
  }
}

function isInsideLockedPurchaseContext(element) {
  const context = element.closest(`${BSS_PURCHASE_CONTEXT}, [${BSS_DISABLED_ATTRIBUTE}]`);
  return Boolean(
    context && (context.hasAttribute(BSS_DISABLED_ATTRIBUTE) || context.querySelector(BSS_LOCK_MARKER))
  );
}

document.addEventListener(
  'click',
  (event) => {
    if (!(event.target instanceof Element)) return;

    const control = event.target.closest(BSS_PURCHASE_CONTROL);
    if (!control || !isInsideLockedPurchaseContext(control)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
  },
  true
);

document.addEventListener(
  'submit',
  (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !isInsideLockedPurchaseContext(form)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
  },
  true
);

let bssRefreshQueued = false;
function refreshBssCustomizations() {
  if (bssRefreshQueued) return;

  bssRefreshQueued = true;
  window.requestAnimationFrame(() => {
    replaceTaxText();
    applyBssAddToCartLocks();
    bssRefreshQueued = false;
  });
}

const observer = new MutationObserver(refreshBssCustomizations);

observer.observe(document.body, {
  childList: true,
  subtree: true,
});

refreshBssCustomizations();
